import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class F1065PageOneService {
  constructor(private http: HttpClient) {}

  /**
   * Load Code Master details for dropdown (SuperPrompt V9)
   * CRITICAL: Must merge globalParams like AngularJS JsonObjectFactory.getJSONObj does
   */
  loadCodeMastDetails(
    baseUrl: string,
    ssoId: string,
    globalService?: any
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    
    // Merge globalParams like AngularJS does in JsonObjectFactory.getJSONObj
    const globalParams = globalService?.globalParams || {};
    const params = {
      ...globalParams,
      action_code: 'kdep1i',
      sso_id: ssoId
    };

    return this.http.get<any>(url, {
      params,
      withCredentials: true
    });
  }

  /**
   * Load Page One Form data (SuperPrompt V9)
   */
  loadFormData(
    baseUrl: string,
    params: any,
    globalService: any
  ): Observable<any> {
    const url = `${baseUrl}/loadPivotFormJson`;
    const mergedParams = { ...globalService?.globalParams, ...params };

    return this.http.get<any>(url, {
      params: mergedParams,
      withCredentials: true
    });
  }

  /**
   * Save Page One Form (SuperPrompt V9)
   * CRITICAL: Payload must match EXACT order from AngularJS
   */
  savePageOneForm(
    baseUrl: string,
    formData: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {},
    processName: string = '1065 Page 1'
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=tkgaam`;

    // Build jsonSettings
    const jsonSettings = {
      tax_year: rowData.TAX_YEAR,
      scenario: rowData.SCENARIO_KEY,
      jcd_key: rowData.JCD_KEY,
      combination_key: rowData.COMBINATION_KEY,
      trans_type_key: formData[0]?.editrows?.[0]?.[0]?.trans_type_key
    };

    // Merge globalParams with filterParams
    const mergedParams = { ...globalService?.globalParams, ...filterParams };

    // Build payload in EXACT order as AngularJS
    const payloadParts: string[] = [];
    
    const encode = (key: string, value: any) => {
      if (value === null || value === undefined) {
        return `${encodeURIComponent(key)}=`;
      }
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    };
    
    // 1. FIRST: jsonSettings and jsonObj (MANDATORY ORDER!)
    payloadParts.push(encode('jsonSettings', JSON.stringify(jsonSettings)));
    payloadParts.push(encode('jsonObj', JSON.stringify(formData)));
    
    // 2. Add mergedParams in EXACT order as AngularJS
    Object.keys(mergedParams).forEach(key => {
      if (key === 'process_name' || key === 'combination_key' || key === 'trans_type_key') {
        return;
      }
      
      const value = mergedParams[key];
      if (value !== undefined && value !== null) {
        if (key === 'checkLockedbj' && typeof value === 'string') {
          payloadParts.push(encode(key, value));
        } else if (typeof value === 'object') {
          payloadParts.push(encode(key, JSON.stringify(value)));
        } else {
          payloadParts.push(encode(key, value.toString()));
        }
      } else {
        payloadParts.push(encode(key, ''));
      }
    });
    
    // 3. Add checkLockedbj, process_name, combination_key, trans_type_key
    payloadParts.push(encode('checkLockedbj', JSON.stringify([
      {
        leid: rowData.LEID,
        combination_key: rowData.COMBINATION_KEY,
        scenario_key: rowData.SCENARIO_KEY
      }
    ])));
    payloadParts.push(encode('process_name', processName));
    payloadParts.push(encode('combination_key', rowData.COMBINATION_KEY.toString()));
    payloadParts.push(encode('trans_type_key', jsonSettings.trans_type_key?.toString() || ''));

    const payloadString = payloadParts.join('&');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, payloadString, {
      headers,
      withCredentials: true
    });
  }
}

